<div odxLayout="flex" class="container">
  <odx-area-header>
    <h5 class="odx-title-5" i18n="@@home.header" data-testid="heading.myProjects">Meine Projekte</h5>
    @if ((isMobile$ | async) === false) {
      <odx-area-header-content class="buttons-container">
        <odx-action-group class="action-group-container">
          <button odxButton data-testid="btn.importProjectFromCrm" (click)="goToCrm()">
            <odx-icon name="plus" alignLeft size="medium"></odx-icon>
            <span i18n="@@home.button.importCrm">CRM Kontaktdaten importieren</span>
          </button>

          @if (isNewProjectVisible$ | async) {
            <button odxButton routerLink="/new-project" data-testid="btn.newProject">
              <odx-icon name="plus" alignLeft size="medium"></odx-icon>
              <span i18n="@@home.button.newProject">Neues Projekt</span>
            </button>
          }
          <app-project-import odxButton></app-project-import>
        </odx-action-group>

        <form odxForm class="form-container" [formGroup]="filterFormGroup">
          <odx-mainfilter-group class="mainfilter-container">
            <odx-form-field>
              <odx-form-field-label i18n="@@home.header.form.projectType">Projekttyp</odx-form-field-label>
              <odx-select
                multiple
                i18n-placeholder="@@home.header.form.projectType.placeholder"
                placeholder="Projekttyp"
                odxFormFieldControl
                formControlName="type"
              >
                @for (projectType of projectTypes; track projectType) {
                  <odx-select-option [value]="projectType">
                    {{ projectType | localizeProjectType }}
                  </odx-select-option>
                }
              </odx-select>
            </odx-form-field>

            <odx-form-field>
              <odx-form-field-label i18n="@@home.header.form.projectStatus">Projektstatus</odx-form-field-label>
              <odx-select
                multiple
                i18n-placeholder="@@home.header.form.projectStatus.placeholder"
                placeholder="Projektstatus"
                odxFormFieldControl
                formControlName="status"
              >
                @for (status of projectStatuses; track status) {
                  <odx-select-option [value]="status.text">
                    {{ status.text | translateProjectStatus | async }}
                  </odx-select-option>
                }
              </odx-select>
            </odx-form-field>
          </odx-mainfilter-group>

          <odx-form-field>
            <input
              i18n-placeholder="@@home.header.form.search.placeholder"
              placeholder="Suche"
              odxFormFieldControl
              formControlName="search"
            />
            <odx-action-group odxFormFieldPrefix>
              <button odxButton size="small"><odx-icon name="search" size="medium" /></button>
            </odx-action-group>
          </odx-form-field>

          <a odxLink href="#" i18n="@@home.header.form.projectType.clearAll" (click)="clearFilters(); $event.preventDefault()">
            Zurücksetzen
          </a>
        </form>
      </odx-area-header-content>
    } @else {
      <odx-action-group class="action-group-container">
        @if (isNewProjectVisible$ | async) {
          <button odxButton [odxDropdown]="createProjectDropdown" data-testid="btn.createProject">
            <odx-icon name="plus" alignLeft size="medium"></odx-icon>
            <span i18n="@@home.button.createProject">Projekt erstellen</span>
          </button>
        } @else {
          <app-project-import odxButton></app-project-import>
        }
        <button odxButton [odxDropdown]="filterOptionsDropdown" #filterDropdown="odxDropdown" data-testid="btn.filterOptions">
          <odx-icon name="filter" alignLeft size="medium"></odx-icon>
          <span i18n="@@home.button.filterOptions">Filteroptionen</span>
        </button>
      </odx-action-group>
    }
  </odx-area-header>

  <div class="scroll h-100">
    <div odxLayout="grid 3@desktop 12@phone 4@tablet" class="project-card-container">
      @for (project of filteredProjects$ | async; track project.id) {
        <app-project-card [project]="project"></app-project-card>
      }
      @if (!(projects$ | async)?.length) {
        <p class="odx-text" i18n="@@home.noProjects">Keine Projekte verfügbar</p>
      }
    </div>
  </div>

  <ng-template #createProjectDropdown>
    <div class="flex-column create-project-dropdown-container">
      <h5 class="odx-title-5" i18n="@@home.createProjectDropdown.header" data-testid="heading.createProject">
        Projekt erstellen
      </h5>

      <button odxButton data-testid="btn.importProjectFromCrm" (click)="goToCrm()" variant="secondary">
        <odx-icon name="plus" alignLeft size="medium"></odx-icon>
        <span i18n="@@home.button.importCrm">CRM Kontaktdaten importieren</span>
      </button>

      @if (isNewProjectVisible$ | async) {
        <button odxButton routerLink="/new-project" data-testid="btn.newProject" variant="secondary">
          <odx-icon name="plus" alignLeft size="medium"></odx-icon>
          <span i18n="@@home.button.newProject">Neues Projekt</span>
        </button>
      }
      <app-project-import odxButton></app-project-import>
    </div>
  </ng-template>

  <ng-template #filterOptionsDropdown>
    <div class="flex-column filter-options-dropdown-container">
      <h5 class="odx-title-5" i18n="@@home.filterOptionsDropdown.header" data-testid="heading.filterOptions">Filteroptionen</h5>

      <form odxForm class="form-container flex-column" [formGroup]="mobileFilterFormGroup">
        <odx-mainfilter-group class="flex-column">
          <odx-form-field>
            <odx-form-field-label i18n="@@home.header.form.projectType">Projekttyp</odx-form-field-label>
            <odx-select
              multiple
              i18n-placeholder="@@home.header.form.projectType.placeholder"
              placeholder="Projekttyp"
              odxFormFieldControl
              formControlName="type"
            >
              @for (projectType of projectTypes; track projectType) {
                <odx-select-option [value]="projectType">
                  {{ projectType | localizeProjectType }}
                </odx-select-option>
              }
            </odx-select>
          </odx-form-field>

          <odx-form-field>
            <odx-form-field-label i18n="@@home.header.form.projectStatus">Projektstatus</odx-form-field-label>
            <odx-select
              multiple
              i18n-placeholder="@@home.header.form.projectStatus.placeholder"
              placeholder="Projektstatus"
              odxFormFieldControl
              formControlName="status"
            >
              @for (status of projectStatuses; track status) {
                <odx-select-option [value]="status.text">
                  {{ status.text | translateProjectStatus | async }}
                </odx-select-option>
              }
            </odx-select>
          </odx-form-field>
        </odx-mainfilter-group>

        <odx-form-field>
          <input
            i18n-placeholder="@@home.header.form.search.placeholder"
            placeholder="Suche"
            odxFormFieldControl
            formControlName="search"
          />
          <odx-action-group odxFormFieldPrefix>
            <button odxButton size="small"><odx-icon name="search" /></button>
          </odx-action-group>
        </odx-form-field>

        <a odxLink href="#" i18n="@@home.header.form.projectType.clearAll" (click)="clearFilters(); $event.preventDefault()">
          Zurücksetzen
        </a>

        <div class="filter-options-buttons">
          <button odxButton data-testid="btn.dismissFilterOptions" (click)="dismissMobileFilters()" variant="secondary">
            <span i18n="@@home.button.dismissFilterOptions">Abbrechen</span>
          </button>
          <button odxButton data-testid="btn.applyFilterOptions" (click)="applyMobileFilters()" variant="primary">
            <span i18n="@@home.button.applyFilterOptions">Anwenden</span>
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</div>
